import axiosInstance from './axiosInstance';

export const listExams = () => axiosInstance.get('/candidate/exams');
export const getExam = (id) => axiosInstance.get(`/candidate/exams/${id}`);

export const startSession = (examId, accessCode) =>
  axiosInstance.post('/candidate/sessions/start', { exam_id: examId, ...(accessCode ? { access_code: accessCode } : {}) });
export const getQuestion = (sessionId, index) => axiosInstance.get(`/candidate/sessions/${sessionId}/question/${index}`);
export const saveAnswer = (sessionId, data) => axiosInstance.post(`/candidate/sessions/${sessionId}/answer`, data);
export const flagActivity = (sessionId, data) => axiosInstance.post(`/candidate/sessions/${sessionId}/flag-activity`, data);
export const submitSession = (sessionId, data) => axiosInstance.post(`/candidate/sessions/${sessionId}/submit`, data);
export const getSessionStatus = (sessionId) => axiosInstance.get(`/candidate/sessions/${sessionId}/status`);
export const getSessionResult = (sessionId) => axiosInstance.get(`/candidate/sessions/${sessionId}/result`);
export const getSessionSections = (sessionId) => axiosInstance.get(`/candidate/sessions/${sessionId}/sections`);

export const flagActivityBeacon = (sessionId, type) => {
  const data = JSON.stringify({ type });
  navigator.sendBeacon(`/api/candidate/sessions/${sessionId}/flag-activity`, data);
};
